import { createRoot } from 'solid-js';
import { createStore, reconcile, unwrap } from 'solid-js/store';
import { State } from '@/config/state';
import rootScope from '@/lib/rootScope';
import { SetStoreFunctionReturning } from '@/helpers/solid/setStoreFunctionReturning';

const [appState, _setAppState] = createRoot(() => createStore<State>({} as any));

const setAppState = ((...args: any[]) => {
  const key = args[0];
  // @ts-ignore
  _setAppState(...args);
  // @ts-ignore
  return rootScope.managers.appStateManager.setByKey(key, unwrap(appState[key]));
}) as SetStoreFunctionReturning<State, Promise<void>>;

const setAppStateSilent = (key: any, value?: any) => {
  if (typeof(key) === 'object') {
    _setAppState(key);
    return;
  }

  _setAppState(key, reconcile(value));
};

const useAppState = () => [appState, setAppState] as const;

const useAppConfig = () => appState.appConfig;

const useIsFrozen = () => !!useAppConfig().freeze_since_date;

export {
  appState,
  useAppState,
  setAppState,
  setAppStateSilent,
  useAppConfig,
  useIsFrozen,
};
